import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import analytics from '@/services/Analytics';

import en from './en.json';
import es from './es.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
};

i18n.on('languageChanged', (language) => analytics.setLanguage(language));

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
